import { render, staticRenderFns } from "./CommunityFaqUpdate.vue?vue&type=template&id=1ce85cb4"
import script from "./CommunityFaqUpdate.vue?vue&type=script&lang=js"
export * from "./CommunityFaqUpdate.vue?vue&type=script&lang=js"
import style0 from "./CommunityFaqUpdate.vue?vue&type=style&index=0&id=1ce85cb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports